import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { destinationGroupApi } from '../../api/lib/destination-group';
import { destinationGroupsKeys } from '../../api/query-keys/destination-groups';

export const useRemoveDestinationGroup = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['destinationGroups']);

  return useMutation({
    mutationFn: (id: number) => {
      return destinationGroupApi.removeDestinationGroup(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: destinationGroupsKeys.all });
      onSuccess?.();
      toast.success(
        `${t('destinationGroups:dialog.destinationGroup')} ${t(
          'destinationGroups:dialog.deleted',
        )}`,
      );
    },
    onError: (err: ApiError) => {
      toast.error(err?.response?.data?.message);
    },
  });
};
